<template>
    <div v-dialogDrag>
        <el-dialog :title="loadingTitle" v-model="dialogVisible" width="560px" center :destroy-on-close="true" :close-on-click-modal="false" @closed="handleClose">
            <el-form :inline="false" :model="formData" ref="rulesForm" label-position="right" label-width="130px">
                <el-form-item label="用户头像：">
                    <img :src="formData.avatar ? formData.avatar : defaultImg" style="width: 60px;height:60px" :onerror="defaultImg">
                </el-form-item>
                <el-form-item label="用户名：" prop="username">
                    {{formData.username}}
                </el-form-item>
                <el-form-item label="用户昵称：" prop="nickname">
                    {{formData.nickname}}
                </el-form-item>
                <el-form-item label="手机号：" prop="mobile">
                    {{formData.mobile}}
                </el-form-item>
                <el-form-item label="创建时间：" prop="mobile">
                    {{formData.create_datetime}}
                </el-form-item>
                <el-form-item label="更新时间：" prop="mobile">
                    {{formData.update_datetime}}
                </el-form-item>
                <el-form-item label="状态：" prop="is_active">
                    <el-switch
                            v-model="formData.is_active"
                            active-color="#13ce66"
                            inactive-color="#ff4949" disabled>
                    </el-switch>
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button @click="handleClose" :loading="loadingSave">取消</el-button>
    <!--            <el-button type="primary" @click="submitData" :loading="loadingSave">确定</el-button>-->
            </template>
        </el-dialog>
    </div>
</template>

<script>
    import {apiSystemUserAdd,apiSystemUserEdit} from "@/api/api";
    import { deepClone } from "@/utils/util";
    export default {
        name: "userDetail",
        emits: ['refreshData', 'closed'],
        data() {
            return {
                dialogVisible:false,
                loadingSave:false,
                loadingTitle:'',
                defaultImg:require('../../../assets/img/avatar.jpg'),
                formData:{
                    name:'',
                    nickname:'',
                    username:'',
                    mobile:'',
                    create_datetime:'',
                    update_datetime:'',
                    is_active:true,
                    avatar:''
                },
            }
        },
        methods:{
            handleClose() {
                this.$emit('closed')
            },
            handleOpen(item,flag) {
                this.loadingTitle=flag
                this.dialogVisible=true
                if(item){
                    this.formData = deepClone(item)
                }
            },
            submitData() {
                this.$refs['rulesForm'].validate(obj=>{
                    if(obj) {
                        this.loadingSave=true
                        let param = {
                            ...this.formData
                        }
                        if(this.formData.id){
                            apiSystemUserEdit(param).then(res=>{
                                this.loadingSave=false
                                if(res.code ==2000) {
                                    this.$message.success(res.msg)
                                    this.handleClose()
                                    this.$emit('refreshData')
                                } else {
                                    this.$message.warning(res.msg)
                                }
                            })
                        }else{
                            apiSystemUserAdd(param).then(res=>{
                                this.loadingSave=false
                                if(res.code ==2000) {
                                    this.$message.success(res.msg)
                                    this.handleClose()
                                    this.$emit('refreshData')
                                } else {
                                    this.$message.warning(res.msg)
                                }
                            })
                        }

                    }
                })
            },
        }
    }
</script>

